import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import './index.css';

ReactDOM.render(<Root />, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/